import { useState, useEffect } from 'react'
// import { fetchAuthSession } from 'aws-amplify/auth'
import NetInfo from '@react-native-community/netinfo'
import { Platform } from 'react-native'
import { useNavigation } from '../../../hooks/useWebNavigation'
import {
    deleteAllTablesLearning,
    getGlobalVersion,
    openDB,
    updateGlobalVersion,
} from '../../../db/indexDB'
import { LEARNING_STORE_NAMES } from '../../../db/constants'
import {
    add_category,
    add_content,
    add_course,
    add_evaluation,
    get_learning,
    reconstructData,
} from '../../../db/learning'
import { send_data_is_connected } from '../../learning/services/sendPending'
import { apiUrl } from '../../../config/config'
import { useDeviceStore } from '../../../redux/zustand/deviceInfoStore'

import {
    TrainingCourseHomeResponse,
    Repository,
} from '../interfaces/trainingCourseHomeInterfaz'
import { getConection, THEME_COLOR_ALERT } from '../../appBar/context/HeaderContext'
import { request_get_training_courses_home } from '../../../services/courses.services'
import { getAuthToken } from '../../../utils/functions.utils'
import { getAlert } from '@/components/appBar/context/AlertsContext'
import { LEARNING_STATUS } from '../constants'

export const useFetchCourses = () => {
    const API_ENDPOINT = apiUrl + '/get_training_courses_home'
    const { deviceId } = useDeviceStore()
    const [isLoading, setIsLoading] = useState(true)
    const [data, setData] = useState<TrainingCourseHomeResponse>()
    const [reloadCounter, setReloadCounter] = useState(0)
    const [isFetching, setIsFetching] = useState(false)
    const navigation = useNavigation()
    const { isConnected, hasInternet } = getConection()
    const { setAlert } = getAlert()
    const getToken = async () => {
        try {
            const token = await getAuthToken('courses_hook')
            return token || ''
        } catch (error) {
            console.error('Error getting token:', error)
            return ''
        }
    }
    const fetch_data = async () => {
        console.log('[useFetchCourses] fetch_data called')
        try {
            console.log('[useFetchCourses] starting fetch_data')
            setIsFetching(true)
            setIsLoading(true)

            if (Platform.OS === 'web') {
                console.log(
                    '[useFetchCourses] Web platform, fetching directly from API',
                )
                const token = await getToken()
                console.log('[useFetchCourses] token obtained:', !!token)
                if (!token) {
                    console.log('[useFetchCourses] No token, trying local DB')
                    try {
                        const db = await openDB()
                        const {
                            categories: localCategories,
                            courses: localCourses,
                            contents: localContents,
                            evaluations: localEvaluations,
                        } = await get_learning(db)
                        const data_local = reconstructData(
                            localCategories,
                            localCourses,
                            localContents,
                            localEvaluations,
                        )
                        console.log(
                            '[useFetchCourses] Using local data:',
                            data_local,
                        )
                        setData(data_local as never)
                    } catch (error) {
                        console.log('[useFetchCourses] No local data either:', error)
                        setData({ single: { categories: [] } } as never)
                    }
                    setIsLoading(false)
                    setIsFetching(false)
                    return
                }
                const data = await request_get_training_courses_home({
                    authToken: token,
                    version: null,
                    device_key: deviceId,
                })
                console.log('[useFetchCourses] API response:', JSON.stringify(data))
                setData(data)
                setIsLoading(false)
                setIsFetching(false)
                return
            }

            // console.log('[useFetchCourses] Mobile platform, using DB')
            // console.log('[useFetchCourses] calling openDB')
            const db = await openDB()
            // console.log('[useFetchCourses] db opened:', db)
            //primero consumo local
            // console.log('[useFetchCourses] calling get_learning')
            const {
                categories: localCategories,
                courses: localCourses,
                contents: localContents,
                evaluations: localEvaluations,
            } = await get_learning(db)
            // console.log('[useFetchCourses] local data:', { localCategories: localCategories?.length, localCourses: localCourses?.length, localContents: localContents?.length, localEvaluations: localEvaluations?.length })
            const data_local = reconstructData(
                localCategories,
                localCourses,
                localContents,
                localEvaluations,
            )
            // console.log('[DEBUG K JSON DATA]', JSON.stringify(data_local))
            // console.log('[DEBUG APK] Data local reconstruida:', JSON.stringify(data_local))
            setData(data_local as never)

            setIsLoading(false)
            if (!isConnected || !hasInternet) {
                setAlert(
                    'No tienes conexión',
                    'white',
                    'wifi-off',
                    THEME_COLOR_ALERT.ERROR,
                )
            }
            if (isConnected && hasInternet) {
                // console.log('[useFetchCourses] isConnected:', isConnected, 'hasInternet:', hasInternet)
                // console.log('---------------1 tengo internet verifico si hay actualizacion----------------')
                const token = await getToken()
                // console.log('[useFetchCourses] token obtained:', !!token)

                const data_update_devices_users = {
                    authToken: token,
                    device_key: deviceId,
                    table: 'training_courses_caches',
                }
                // console.log('[DEBUG APK] deviceId:', deviceId, 'token:', token ? 'presente' : 'ausente')
                let response_pending = await send_data_is_connected(
                    db,
                    token,
                    data_update_devices_users,
                )

                const currentGlobalVersion = response_pending
                    ? null
                    : await getGlobalVersion(
                          db,
                          LEARNING_STORE_NAMES.LEARNING_VERSION,
                      )

                if (!token) {
                    // console.log('[DEBUG APK] Sin token, mantengo datos locales')
                    setIsLoading(false)
                    setIsFetching(false)
                    return
                }
                const data = await request_get_training_courses_home({
                    authToken: token,
                    version: currentGlobalVersion,
                    device_key: deviceId,
                })

                if (data.status == 1 && isConnected && hasInternet) {
                    // console.log('[DEBUG APK] Hay info nueva en cursos, borro tablas locales y guardo')
                    await deleteAllTablesLearning(db)
                    setData(data)
                    const saveDataResult = save_data(data)
                    const saveDataCategories = saveDataResult?.categories || []

                    const saveDataCourses = saveDataResult?.courses || []
                    const saveDataModuls = saveDataResult?.moduls || []
                    const saveDataEvaluations = saveDataResult?.evaluations || []

                    // Serializar inserciones para evitar locks
                    if (
                        !Array.isArray(saveDataCourses) ||
                        saveDataCourses.length === 0
                    ) {
                        console.log(
                            '[DEBUG APK] El array de cursos está vacío o no es array, no se guardarán cursos.',
                        )
                    }
                    for (const course of saveDataCourses) {
                        try {
                            // Mapeo plano compatible con la tabla learning_courses
                            const courseToSave = {
                                _id: course._id,
                                blocked_by: JSON.stringify(course.blocked_by),
                                date: course.date ?? '',
                                title: course.title,
                                cover_image: course.cover_image,
                                description_short: course.description_short,
                                description_long: course.description_long,
                                share: course.share,
                                progressive_mode: course.progressive_mode,
                                likes: course.likes,
                                evaluations: JSON.stringify(course.evaluations),
                                type: JSON.stringify(course.type),
                                moduls: JSON.stringify(course.moduls),
                                status_liked: course.status_liked,
                                status: course.status,
                                category_id: course.category_id,
                                course_index: course.course_index,
                                certificate: JSON.stringify(
                                    course.certificate || null,
                                ),
                                download_zip: JSON.stringify(
                                    course.download_zip || null,
                                ),
                            }
                            // console.log('[Debug K] Voy a guardar el curso:', courseToSave._id, courseToSave.title, courseToSave.category_id)
                            await add_course(db, courseToSave)
                            // console.log('[DEBUG APK] Curso guardado OK:', course._id, course.title)
                        } catch (error) {
                            // console.log('[DEBUG APK] Error guardando curso:', course._id, error, JSON.stringify(course))
                            // console.log('[DEBUG APK] [COURSE RAW]:', JSON.stringify(course))
                            // console.log('[DEBUG APK] [COURSE TO SAVE]:', JSON.stringify({
                            //     _id: course._id,
                            //     blocked_by: JSON.stringify(course.blocked_by),
                            //     date: course.date ?? '',
                            //     title: course.title,
                            //     cover_image: course.cover_image,
                            //     description_short: course.description_short,
                            //     description_long: course.description_long,
                            //     share: course.share,
                            //     progressive_mode: course.progressive_mode,
                            //     likes: course.likes,
                            //     evaluations: JSON.stringify(course.evaluations),
                            //     type: JSON.stringify(course.type),
                            //     moduls: JSON.stringify(course.moduls),
                            //     status_liked: course.status_liked,
                            //     status: course.status,
                            //     category_id: course.category_id,
                            //     course_index: course.course_index,
                            //     certificate: JSON.stringify(course.certificate || null),
                            //     download_zip: JSON.stringify(course.download_zip || null),
                            // }))
                            try {
                                const { captureAndSaveDataError } =
                                    await import('../../../utils/errorUtils')
                                await captureAndSaveDataError({
                                    log: `[ERROR] Guardando curso: ${course._id} - ${course.title} - ${error?.message || error}`,
                                    date: new Date().toISOString(),
                                    end: 'add_course',
                                    additional: JSON.stringify(course),
                                })
                            } catch (err2) {
                                console.log(
                                    '[DEBUG APK] Error guardando en ERROR_LOGS:',
                                    err2,
                                )
                            }
                        }
                    }
                    for (const modul of saveDataModuls) {
                        try {
                            // Filtrar solo los campos permitidos por la tabla
                            const modulToSave = {
                                _id: modul._id,
                                evaluations: JSON.stringify(modul.evaluations || []),
                                course_name: modul.course_name ?? '',
                                media: modul.media ?? '',
                                content_type: modul.content_type ?? '',
                                title: modul.title ?? '',
                                description_short: modul.description_short ?? '',
                                description_long: modul.description_long ?? '',
                                media_slides: JSON.stringify(
                                    modul.media_slides || [],
                                ),
                                link_share: modul.link_share ?? '',
                                status:
                                    typeof modul.status === 'number'
                                        ? modul.status
                                        : 0,
                                cover_image: modul.cover_image ?? '',
                                certificate:
                                    typeof (modul as any).certificate === 'string'
                                        ? (modul as any).certificate
                                        : JSON.stringify(
                                              (modul as any).certificate || null,
                                          ),
                            }
                            await add_content(db, modulToSave)
                            // console.log('[DEBUG APK] Módulo guardado:', modul._id, modul.title)
                        } catch (error) {
                            // console.log('[DEBUG APK] Error guardando módulo:', modul._id, error, JSON.stringify(modul))
                            // console.log('[DEBUG APK] [MODUL RAW]:', JSON.stringify(modul))
                            // reconstruir el objeto para el log en caso de error
                            const modulLog = {
                                _id: modul._id,
                                evaluations: JSON.stringify(modul.evaluations || []),
                                course_name: modul.course_name ?? '',
                                media: modul.media ?? '',
                                content_type: modul.content_type ?? '',
                                title: modul.title ?? '',
                                description_short: modul.description_short ?? '',
                                description_long: modul.description_long ?? '',
                                media_slides: JSON.stringify(
                                    modul.media_slides || [],
                                ),
                                link_share: modul.link_share ?? '',
                                status:
                                    typeof modul.status === 'number'
                                        ? modul.status
                                        : 0,
                                cover_image: modul.cover_image ?? '',
                                certificate:
                                    typeof (modul as any).certificate === 'string'
                                        ? (modul as any).certificate
                                        : JSON.stringify(
                                              (modul as any).certificate || null,
                                          ),
                            }
                            console.log(
                                '[DEBUG APK] [MODUL TO SAVE]:',
                                JSON.stringify(modulLog),
                            )
                        }
                    }

                    // console.log('[DEBUG APK] Procesando', saveDataCategories.length, 'categorías')
                    for (const category of saveDataCategories) {
                        try {
                            // console.log('[DEBUG APK] Guardando categoría:', category._id, category.category_name)
                            await add_category(db, category)
                            // console.log('[DEBUG APK] Categoría guardada:', category._id, category.category_name)
                        } catch (error) {
                            console.log(
                                '[DEBUG APK] Error guardando categoría:',
                                category._id,
                                error,
                                JSON.stringify(category),
                            )
                            console.log(
                                '[DEBUG APK] [CATEGORY RAW]:',
                                JSON.stringify(category),
                            )
                            try {
                                const { captureAndSaveDataError } =
                                    await import('../../../utils/errorUtils')
                                await captureAndSaveDataError({
                                    log: `[ERROR] Guardando categoría: ${category._id} - ${category.category_name} - ${error?.message || error}`,
                                    date: new Date().toISOString(),
                                    end: 'add_category',
                                    additional: JSON.stringify(category),
                                })
                            } catch (err2) {
                                console.log(
                                    '[DEBUG APK] Error guardando en ERROR_LOGS:',
                                    err2,
                                )
                            }
                        }
                    }
                    for (const evaluation of saveDataEvaluations) {
                        try {
                            // Mapeo plano compatible con la tabla learning_evaluations
                            const evaluationToSave = {
                                _id: evaluation._id,
                                name: evaluation.name,
                                can_repeat: !!evaluation.can_repeat,
                                can_repeat_failure: !!evaluation.can_repeat_failure,
                                can_repeat_success: !!evaluation.can_repeat_success,
                                type_assessment: JSON.stringify(
                                    evaluation.type_assessment || [],
                                ),
                                questions: JSON.stringify(
                                    evaluation.questions || [],
                                ),
                                count_questions: String(
                                    evaluation.count_questions ??
                                        (evaluation.questions
                                            ? evaluation.questions.length
                                            : ''),
                                ),
                                questions_random:
                                    typeof evaluation.questions_random !==
                                    'undefined'
                                        ? !!evaluation.questions_random
                                        : !!evaluation.random,
                                assessmentResult: evaluation.assessmentResult ?? '',
                                survey: JSON.stringify(evaluation.survey || []),
                                approval_rate: String(
                                    evaluation.approval_rate ?? '',
                                ),
                                allow_partial_submission: evaluation.allow_partial_submission, // si me llega la key la guardo, no me llega guardo false
                                max_retry_attempts: evaluation.max_retry_attempts ?? null, // si me llega la key la guardo, no me llega guardo null
                                retry_only_failed: evaluation.retry_only_failed ?? null, // si me llega la key la guardo, no me llega guardo null
                                attempts_count: evaluation.attempts_count ?? null,
                                failed_questions: evaluation.failed_questions ?? null,
                                partial_anmswers: evaluation.partial_anmswers ?? null,
                                attempt_expiry_days: evaluation.attempt_expiry_days ?? null,
                                attempt_expiry_minutes: evaluation.attempt_expiry_minutes ?? null,
                                attempt_reset_days: evaluation.attempt_reset_days ?? null,
                                attempt_reset_minutes: evaluation.attempt_reset_minutes ?? null,
                                attempt_date_created: evaluation.attempt_date_created ?? null,
                            }
                            await add_evaluation(db, evaluationToSave)
                            // console.log('[DEBUG APK] Evaluación guardada:', evaluation._id, evaluation.name)
                        } catch (error) {
                            // console.log('[DEBUG APK] Error guardando evaluación:', evaluation._id, error, JSON.stringify(evaluation))
                            // console.log('[DEBUG APK] [EVALUATION RAW]:', JSON.stringify(evaluation))
                            // console.log('[DEBUG APK] [EVALUATION TO SAVE]:', JSON.stringify({
                            //     _id: evaluation._id,
                            //     name: evaluation.name,
                            //     can_repeat: !!evaluation.can_repeat,
                            //     can_repeat_failure: !!evaluation.can_repeat_failure,
                            //     can_repeat_success: !!evaluation.can_repeat_success,
                            //     type_assessment: JSON.stringify(evaluation.type_assessment || []),
                            //     questions: JSON.stringify(evaluation.questions || []),
                            //     count_questions: String(evaluation.count_questions ?? (evaluation.questions ? evaluation.questions.length : '')),
                            //     questions_random: typeof evaluation.questions_random !== 'undefined' ? !!evaluation.questions_random : !!evaluation.random,
                            //     assessmentResult: evaluation.assessmentResult ?? '',
                            //     survey: JSON.stringify(evaluation.survey || []),
                            //     approval_rate: String(evaluation.approval_rate ?? ''),
                            // }))
                        }
                    }
                    if (data.single) {
                        if (data['single']['categories']) {
                            const version_update = data.single.data_version
                            await updateGlobalVersion(
                                db,
                                LEARNING_STORE_NAMES.LEARNING_VERSION,
                                version_update,
                            )
                            console.log(
                                '[DEBUG APK] Versión de datos actualizada:',
                                version_update,
                            )
                        }
                    }
                }
            }
        } catch (error) {
            console.error(
                '[useFetchCourses] Error in fetch_data:',
                error.message,
                error.stack,
            )
            setIsLoading(false)
        } finally {
            console.log('[useFetchCourses] fetch_data finished')
            setIsLoading(false) // Ocultar indicador de carga al finalizar la solicitud principal
            setIsFetching(false)
        }
    }

    // recibo la res y la desestructuro para tener por separado categorias, cursos, modulos y evaluaciones
    const save_data = (data: TrainingCourseHomeResponse) => {
        try {
            // console.log('[DEBUG K] save_data: data.single.categories:', data.single?.categories?.length || 0)
            const array_categories = data.single?.categories || [] // separar en un array
            const array_repository: Repository[] = []
            const array_moduls = []
            const array_evaluations = []
            let categoria_vacia = data.single?.categories?.filter(
                (cat) => cat.category_name === 'Uso & Aplicación de Marca',
            )

            // console.log('[DEBUG K] ==> CATEGORIA VACIA]', categoria_vacia)
            // esta ok
            const categories = array_categories.map((category) => {
                const cursos = category.repository

                cursos.forEach((curso) => {
                    array_repository.push({ ...curso, category_id: category._id })
                })

                return {
                    // id: category.id,
                    _id: category._id,
                    category_name: category.category_name,
                    description: category.description,
                    cover_image: category.cover_image,
                    channel_icon: category.channel_icon,
                    index: category.index,
                    action: category.action,
                    blocked_by: category.blocked_by,
                    repository: category.repository.map((course) => course._id),
                    category_home: category.category_home,
                    status: category.status,
                    // curses: category.curses,
                    courses: category.courses,
                }
            })

            const courses = array_repository.map((course) => {
                const moduls = course.moduls

                moduls.forEach((module) => {
                    array_moduls.push({
                        ...module,
                        course_id: course._id,
                    })
                })

                // Si el curso viene bloqueado del servidor pero su(s) bloqueante(s)
                // ya están COMPLETED en la misma respuesta, guardarlo como PENDIENTE.
                // Así evitamos que fetch_data re-bloquee cursos que el cliente ya desbloqueó.
                let effectiveStatus = course.status
                if (
                    effectiveStatus === LEARNING_STATUS.BLOCKED &&
                    Array.isArray(course.blocked_by) &&
                    course.blocked_by.length > 0
                ) {
                    const allBlockersCompleted = course.blocked_by.every((blockerId: string) => {
                        const blocker = array_repository.find((c) => c._id === blockerId)
                        return blocker?.status === LEARNING_STATUS.COMPLETED
                    })
                    if (allBlockersCompleted) {
                        effectiveStatus = LEARNING_STATUS.PENDIENTE
                    }
                }

                let new_course = {
                    _id: course._id,
                    title: course.title,
                    cover_image: course.cover_image,
                    date: course.date,
                    description_long: course.description_long,
                    description_short: course.description_short,
                    likes: course.likes,
                    share: course.share,
                    type: course.type,
                    contador_likes: course.contador_likes,
                    moduls: course.moduls.map((module) => module._id),
                    status_liked: course.status_liked,
                    status: effectiveStatus,
                    progressive_mode: course.progressive_mode,
                    blocked_by: course.blocked_by,
                    evaluations:
                        course.evaluations != null && course.evaluations.length > 0
                            ? course.evaluations.map((eva) => eva._id)
                            : course.evaluations,
                    category_id: course.category_id,
                    course_index: course.course_index,
                    certificate: course.certificate,
                    download_zip: course.download_zip,
                }

                if (
                    course.evaluations != null &&
                    course.evaluations &&
                    course.evaluations.length > 0
                ) {
                    for (const evaluation of course.evaluations) {
                        array_evaluations.push({
                            ...evaluation,
                            course_id: course._id,
                        })
                    }
                }

                return new_course
            })

            const moduls = array_moduls.map((modul) => {
                let new_modul = {
                    _id: modul._id,
                    status_liked: modul.status_liked,
                    course_name: modul.course_name,
                    media: modul.media,
                    content_type: modul.content_type,
                    title: modul.title,
                    description_short: modul.description_short,
                    description_long: modul.description_long,
                    media_slides: modul.media_slides,
                    users_comments: modul.users_comments,
                    link_share: modul.link_share,
                    likes: modul.likes,
                    status: modul.status,
                    course_id: modul.course_id,
                    evaluations:
                        modul.evaluations.length > 0
                            ? modul.evaluations.map((eva) => eva._id)
                            : modul.evaluations,
                    cover_image: modul.cover_image,
                }

                if (modul.evaluations && modul.evaluations.length > 0) {
                    for (const evaluation of modul.evaluations) {
                        array_evaluations.push({
                            ...evaluation,
                            modul_id: modul._id,
                        })
                    }
                }

                return new_modul
            })

            // console.log('🚀 ~253 termino save data..')
            console.log(
                '[DEBUG APK] save_data: procesadas',
                categories.length,
                'categorías,',
                courses.length,
                'cursos,',
                moduls.length,
                'módulos,',
                array_evaluations.length,
                'evaluaciones',
            )

            return {
                categories,
                courses,
                moduls,
                evaluations: array_evaluations,
            }
        } catch (error) {
            throw new Error(error.message)
        }
    }

    useEffect(() => {
        const unsubscribe = navigation.addListener('focus', () => {
            setReloadCounter((prevCounter) => prevCounter + 1)
        })

        return unsubscribe
    }, [navigation])

    const setReloadFetchCourses = () => {
        setReloadCounter((prevCounter) => prevCounter + 1)
    }

    useEffect(() => {
        if (reloadCounter > 0) {
            // El propio fetch_data maneja isLoading/isFetching; evitar dobles toggles y flicker
            fetch_data().catch(() => {})
        }
    }, [reloadCounter])

    return {
        data,
        isLoading,
        reload: reloadCounter,
        fetch_data,
        setIsLoading,
        setReloadFetchCourses,
        isFetching,
    }
}
